import React from "react";
import Forgotpassword from "../../components/Auth/ForgotPasswordLayer";
import "../../custom.css";

const ForgotPasswordPage = () => {
  return (
    <>

      {/* Forgotpassword */}
      <Forgotpassword />

    </>
  );
};

export default ForgotPasswordPage; 
